import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  const tagColorMap: Record<string, string> = {
    accent: 'bg-accent-100 text-accent-700',
    primary: 'bg-primary-100 text-primary-700',
    secondary: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            实时追踪网红圈最新动态，不错过任何一个热点
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-0.5 bg-background-200/70"></div>

          <div className="space-y-5">
            {updatesData.map((update) => (
              <div key={update.id} className="relative flex gap-4 md:gap-6 pl-0">
                <div className="relative z-10 w-10 md:w-12 flex flex-col items-center">
                  <div className="w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-primary-300 bg-background-50"></div>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-all cursor-pointer">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 font-medium">
                      {update.date}
                    </span>
                    <span className="text-xs text-foreground-300">|</span>
                    <span className="text-xs text-foreground-400">{update.time}</span>
                    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${tagColorMap[update.tagColor] || tagColorMap.primary}`}>
                      {update.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {update.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}